module.exports = __webpack_public_path__ + "img/RX-RAD-CONVENCIONAL-Moviles-1.9a7e8942.png";